<template>
  <v-btn icon flat color="grey" class="mr-3" @click="$router.go(-1)">
    <v-icon>arrow_back</v-icon>
  </v-btn>
</template>

<script>
export default {};
</script>

<style>
</style>
